<template>
  <b-card-code title="">
    <div class="row mb-2">
      <div class="col-lg-6">
        <h4>Torony daruk listája</h4>
      </div>
      <div class="col-lg-6 text-right">
        <button
          class="btn btn-primary"
          @click="$router.push('/tower-cranes/create')"
        >
          Új torony daru
        </button>
      </div>
      <div class="col-lg-12 mt-2 text-right">
        <b-badge
          variant="primary"
          class="mr-1"
        >
          Összes torony daru: {{ rows.length }}
        </b-badge>
      </div>
    </div>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Name -->
        <div
          v-if="props.column.field === 'name'"
          class="text-nowrap"
        >
          <span
            class="text-nowrap"
            @click="selectedData = props.row;$bvModal.show('tower_crane_data');setTowerCraneDetails(props.row)"
          >
            {{ props.row.name }}
          </span>
        </div>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'is_working'">
          <b-badge
            :variant="props.row.is_working ? 'success' : 'secondary'"
            style="color: white !important;"
          >
            {{ props.row.is_working ? 'Felszerelve' : 'Leszerelve' }}
          </b-badge>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="$router.push(`/tower-cranes/edit/${props.row.id}`)">
                <feather-icon
                  icon="Edit2Icon"
                  size="16"
                  class="mr-50"
                />
                <span>Szerkesztés</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteThisTowerCrane(props.row.id)">
                <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="mr-50"
                />
                <span>Törlés</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">Megjelenítés</span>
            <b-form-select
              v-model="pageLength"
              size="sm"
              :options="['3','5','10', '25', '50']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap">-ig a {{ props.total }} elemet</span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <!-- Tower Crane Details Modal -->
    <b-modal
      id="tower_crane_data"
      title="Torony daru adatai"
      size="lg"
      hide-footer
    >
      <b-row class="my-1 pl-1 pr-1">
        <b-col
          lg="12"
          class="mt-1"
        >
          <b>Torony daru adatok</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Megnevezés: <b>{{ selectedData.name }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Gyártó: <b>{{ selectedData.brand }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Típus: <b>{{ selectedData.type }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Gyártási szám: <b>{{ selectedData.manufacturing_number }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Gyártási év: <b>{{ selectedData.year_of_manufacture }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Állapot:
          <b-badge
            :variant="selectedData.is_working ? 'success' : 'secondary'"
            style="color: white !important;"
          >
            {{ selectedData.is_working ? 'Felszerelve' : 'Leszerelve' }}
          </b-badge>
        </b-col>
        <b-col
          lg="12"
          class="mt-3"
        >
          <hr>
          <b>Összes felszerelési/leszerelési napló ({{ towerCraneLogs.length }} db)</b>
        </b-col>
        <b-col v-if="towerCraneLogs.length === 0">
          <p class="text-muted">
            Még nincs rögzített napló.
          </p>
        </b-col>
        <b-col v-else>
          <table class="table table-responsive">
            <tr>
              <th><b>Üzemeltető cég</b></th>
              <th><b>Helyszín/Építmény</b></th>
              <th><b>Felszerelés dátuma</b></th>
              <th><b>Leszerelés dátuma</b></th>
              <th><b>Állapot</b></th>
              <th><b>Összes vizsgálat</b></th>
              <th><b>Következő vizsgálat</b></th>
            </tr>
            <tr
              v-for="log_data in towerCraneLogs"
              :key="log_data.id"
            >
              <td>{{ log_data.operating_company_name }}</td>
              <td>
                {{ getProjectName(log_data.place_of_installation) }}
                <br>
                <small class="text-muted">{{ log_data.building }}</small>
              </td>
              <td>{{ log_data.date_of_installation }}</td>
              <td>{{ log_data.uninstallation_date || 'Aktív' }}</td>
              <td>
                <b-badge
                  :variant="log_data.is_active ? 'success' : 'secondary'"
                  style="color: white !important;"
                >
                  {{ log_data.is_active ? 'Aktív' : 'Leszerelve' }}
                </b-badge>
              </td>
              <td>
                <div v-if="log_data.periodic_inspection && log_data.periodic_inspection.length > 0">
                  <b-badge
                    v-for="(inspection, index) in log_data.periodic_inspection"
                    :key="index"
                    variant="info"
                    class="mr-1 mb-1"
                    style="color: white !important;"
                  >
                    {{ inspection.type }}: {{ inspection.review_date }}
                  </b-badge>
                </div>
                <span
                  v-else
                  class="text-muted"
                >
                  Nincs vizsgálat
                </span>
              </td>
              <td>
                <span v-if="getNextInspectionDate(log_data) && log_data.is_active">
                  {{ getNextInspectionDate(log_data) }}
                </span>
                <span
                  v-else-if="!log_data.is_active"
                  class="text-muted"
                >
                  Leszerelve
                </span>
                <span
                  v-else
                  class="text-muted"
                >
                  Nincs adat
                </span>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </b-modal>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BBadge, BPagination, BFormSelect, BDropdown, BDropdownItem, BCol, BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'

export default {
  components: {
    BCardCode,
    VueGoodTable,
    BBadge,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCol,
    BRow,
  },
  data() {
    return {
      pageLength: 25,
      dir: false,
      selectedData: {},
      towerCraneLogs: [],
      columns: [
        {
          label: 'Megnevezés',
          field: 'name',
        },
        {
          label: 'Gyártó',
          field: 'brand',
        },
        {
          label: 'Típus',
          field: 'type',
        },
        {
          label: 'Gyártási szám',
          field: 'manufacturing_number',
        },
        {
          label: 'Gyártási év',
          field: 'year_of_manufacture',
        },
        {
          label: 'Állapot',
          field: 'is_working',
        },
        {
          label: 'Műveletek',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
      projects: [],
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        return true
      }
      return false
    },
  },
  mounted() {
    this.loadTowerCraneList()
    this.getProjects()
  },
  methods: {
    getProjects() {
      axios({
        method: 'get',
        url: 'project/list',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.projects = response.data
      })
    },
    getProjectName(projectId) {
      if (!projectId) return '-'
      const project = this.projects.find(p => p.id == projectId)
      return project ? project.name : projectId
    },
    uninstallTowerCrane(id) {
      axios({
        method: 'post',
        url: `tower-crane/${id}/uninstall`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres leszerelés!',
            text: 'A torony daru sikeresen leszerelve.',
            variant: 'success',
          },
        })
        this.loadTowerCraneList()
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiba történt!',
            text: 'A torony daru leszerelése sikertelen.',
            variant: 'danger',
          },
        })
      })
    },
    deleteThisTowerCrane(id) {
      axios({
        method: 'delete',
        url: `tower-crane/delete/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres törlés!',
            text: 'A torony daru törölve lett.',
            variant: 'success',
          },
        })
        this.loadTowerCraneList()
      })
    },
    loadTowerCraneList() {
      axios({
        method: 'get',
        url: 'tower-crane/list',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.rows = response.data
      })
    },

    setTowerCraneDetails(towerCraneData) {
      // A total_logs adatok már az objektumban vannak, csak beállítjuk
      this.towerCraneLogs = towerCraneData.total_logs || []
    },

    getLatestInspection(log) {
      if (log.periodic_inspection && Array.isArray(log.periodic_inspection) && log.periodic_inspection.length > 0) {
        return log.periodic_inspection[log.periodic_inspection.length - 1]
      }
      return null
    },

    getNextInspectionDate(log) {
      const latestInspection = this.getLatestInspection(log)
      let baseDate

      if (latestInspection && latestInspection.review_date) {
        baseDate = new Date(latestInspection.review_date)
      } else if (log.date_of_installation) {
        baseDate = new Date(log.date_of_installation)
      } else {
        return null
      }

      // 8 hónap hozzáadása
      baseDate.setMonth(baseDate.getMonth() + 8)
      return baseDate.toISOString().split('T')[0]
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
